/* istanbul ignore file */
export * from './ChatBot';
